var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChecmarkRawIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M5.69336 15.1143C6.1123 15.1143 6.44531 14.9316 6.68164 14.5664L14.5127 2.18066C14.6953 1.90137 14.7598 1.67578 14.7598 1.4502C14.7598 0.923828 14.416 0.569336 13.8789 0.569336C13.4922 0.569336 13.2773 0.698242 13.041 1.07422L5.65039 12.9336L1.76172 7.69141C1.51465 7.3584 1.27832 7.21875 0.923828 7.21875C0.386719 7.21875 0 7.59473 0 8.13184C0 8.35742 0.0966797 8.60449 0.279297 8.84082L4.67285 14.5449C4.97363 14.9316 5.27441 15.1143 5.69336 15.1143Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecmarkRawIcon);
export default __webpack_public_path__ + "static/media/checmark_raw_icon.f5832ea968f897f3bb9b3f68433b5e59.svg";
export { ForwardRef as ReactComponent };